// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Icon-m_mIVARo7RQ2WyaYuWKCrm {
  text-align: center;
}

.Icon-m_PGhZ4qXQO1WIOqj8x53K {
  font-size: 3rem;
}

.Icon-m_UWJKngdTpkj3Bt5xdxkX {
  font-size: 1rem;
}`, "",{"version":3,"sources":["webpack://./client/shared/genericComponents/Icon/Icon.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".iconContainer {\n  text-align: center;\n}\n\n.icon {\n  font-size: 3rem;\n}\n\n.label {\n  font-size: 1rem;\n}"],"sourceRoot":""}]);
// Exports
export var iconContainer = `Icon-m_mIVARo7RQ2WyaYuWKCrm`;
export var icon = `Icon-m_PGhZ4qXQO1WIOqj8x53K`;
export var label = `Icon-m_UWJKngdTpkj3Bt5xdxkX`;
export default ___CSS_LOADER_EXPORT___;
